import {
  Box,
  Button,
  Collapse,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import LanguageSelector, {
  getLanguageString,
  suppoertedLanguages,
} from "./LanguageSelector";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import Label from "../../libs/rhf-mui/ui/Label";
import { useTranslation } from "react-i18next";
import { useGV } from "../GV";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import AuthHelper from "../heplers/AuthHelper";
import { useAppContext } from "../../libs/app-core/AppContext";
import { useLocation } from "react-router-dom";
import TranslateIcon from "@mui/icons-material/Translate";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { R } from "../R";

const MemberNavbar = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const GV = useGV();
  const ctx = useAppContext();

  const location = useLocation();
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  function btn_Logout_Click() {
    if (GV == null) {
      throw new_ErrorAlert("ERROR! GV==null !!!");
    }

    AuthHelper.Logout(GV, ctx);
  }

  return (
    <Box
      sx={{
        my: {
          xs: 2,
          sm: 0,
        },
      }}
    >
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
        }}
      >
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{
            mr: 2,
            /* gpt: 方形的 Hover */
            borderRadius: "4px",
            "&:hover": {
              boxShadow: "none",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
            display: location.pathname === "/login" ? "none" : "flex",
            alignItems: "center",
          }}
          onClick={btn_Logout_Click}
        >
          <LogoutIcon />

          <Label variant="button" sx={{ mr: 1 }}>
            {t("登出")}
          </Label>
        </IconButton>

        <LanguageSelector />
      </Box>

      <Box sx={{ display: { sm: "none" } }}>
        <Button color="inherit" onClick={(e) => setOpen(true)}>
          <MenuIcon />
        </Button>
        <Drawer open={open} onClose={toggleDrawer(false)} anchor="right">
          <Container sx={{ width: "300px" }}>
            <List sx={{ color: R.color.primary }}>
              <ListItemButton
                onClick={() => {
                  setExpanded(!expanded);
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <TranslateIcon />
                    <Typography variant="subtitle2">
                      {getLanguageString(i18n.language)}
                    </Typography>
                  </Box>
                  <ArrowLeftIcon
                    sx={[
                      {
                        transition: "0.2s",
                      },
                      expanded
                        ? {
                            transform: "rotate(-90deg)",
                          }
                        : {
                            transform: "rotate(0)",
                          },
                    ]}
                  />
                </Box>
              </ListItemButton>
              <Collapse in={expanded}>
                {suppoertedLanguages
                  .filter((lang) => lang !== i18n.language)
                  .map((lang) => (
                    <ListItemButton
                      key={lang}
                      onClick={() => {
                        i18n.changeLanguage(lang);

                        setExpanded(false);
                        setOpen(false);
                      }}
                      sx={{
                        pl: 8,
                      }}
                    >
                      {getLanguageString(lang)}
                    </ListItemButton>
                  ))}
              </Collapse>
              <ListItemButton
                sx={{
                  display: location.pathname === "/login" ? "none" : "flex",
                }}
                onClick={() => AuthHelper.Logout(GV, ctx)}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <LogoutIcon />
                  <Typography variant="subtitle2">{t("登出")}</Typography>
                </Box>
              </ListItemButton>
            </List>
          </Container>
        </Drawer>
      </Box>
    </Box>
  );
};
export default MemberNavbar;
